import AuthService from "@/services/authService";

import {
  clearToken,
  getToken,
  setMerchantId,
  setToken,
} from "@/lib/authStorage";

import mixpanel from "mixpanel-browser";

/** Mixpanel yalniz prod alan adinda baslatiliyor; bkz. App.jsx. */
const mixpanelHazir = () =>
  typeof window !== "undefined" && window.location.hostname.endsWith(".com");
import { create } from "zustand";

const useAuthStore = create((set) => ({
  isAuth: false,
  loading: true,
  token: getToken(),
  user: null,

  login: async (data) => {
    set({ loading: true });
    try {
      const response = await AuthService.login(data);

      set({
        isAuth: true,
        loading: false,
        token: response.jwtToken.split(" ")[1],
      });
      setToken(response.jwtToken.split(" ")[1]);
      set({ loading: false });

      return response;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },
  ideaSoftLogin: async (data) => {
    set({ loading: true });
    try {
      const response = await AuthService.ideaSoftLogin(data);

      set({
        isAuth: true,
        loading: false,
        token: response.jwtToken.split(" ")[1],
      });
      setToken(response.jwtToken.split(" ")[1]);
      set({ loading: false });

      return response;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },
  checkAuth: async () => {
    set({ loading: true });
    const response = await AuthService.checkAuth();

    response
      ? set({ isAuth: true, loading: false, user: response })
      : set({ isAuth: false, loading: false, user: null });
    // EPS-3961 — yukarida `response` null olabilecegi acikca ele aliniyor ama
    // hemen altinda `response.merchantId` korumasiz okunuyordu; oturum
    // dogrulanamadiginda "Cannot read properties of null (reading 'merchantId')"
    // firlatiyor ve checkAuth `return response`a ulasamiyordu (replikada web
    // baglaminda canli goruldu).
    if (!response) {
      return response;
    }
    setMerchantId(response.merchantId);
    // EPS-3961 — `mixpanel.init` yalniz `.com` alan adinda calisiyor (App.jsx),
    // ama `identify` her ortamda cagriliyordu. Dev/replikada baslatilmamis
    // kutuphaneye gidip "Cannot read properties of undefined (reading
    // 'before_identify')" firlatiyor ve checkAuth `return response`a hic
    // ulasamiyordu. Olcum: panel.egaranti.dev'de her sayfa yuklemesinde hata.
    if (mixpanelHazir()) {
      mixpanel.identify(response.id);
    }
    return response;
  },
  logout: async () => {
    try {
      // Token hâlâ eldeyken sunucuya bildir ki backend'de blacklist'e alınsın
      await AuthService.logout();
    } catch (err) {
      // Backend hata verse bile kullanıcıyı kilitleme — yine de local temizliği yap
    } finally {
      set({ isAuth: false, token: null });
      clearToken();
    }
  },
  changePassword: async (bodyObj) => {
    const response = AuthService.changePassword(bodyObj);
    return response;
  },
}));

export default useAuthStore;
